// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  &.previous-searches-desktop {
    .multiline-ellipsis {
      display: block;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .previous-searches-header {
      font-weight: bold;
      font-size: ${(props) => props.theme.typography.fontSizes.fs20};
      font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
      margin-bottom: 20px;
      line-height: 26px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        margin-top: 25px;
        font-size: ${(props) => props.theme.typography.fontSizes.fs16};
        margin-bottom: 16px;
      }
      @media ${(props) => props.theme.mediaQuery.mediumOnly} {
        font-size: ${(props) => props.theme.typography.fontSizes.fs14};
        line-height: 20px;
        margin-bottom: 18px;
      }
    }
    .previous-searches-header.redesign {
      font-size: ${(props) => props.theme.typography.fontSizes.fs14};
      @media ${(props) => props.theme.mediaQuery.large} {
        margin-left: 0px;
        margin-bottom: 16px;
      }
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin-left: 0;
        margin-top: 0;
      }
    }
    .product-tile-wrapper {
      margin-bottom: 20px;
    }
    .previous-searches-grid {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-between;
    }
  }
`;
